import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    waitText: String,
    cooldownDuration: String,
  };

  connect() {
    this.originalText = this.element.textContent.trim();
    this.isCoolingDown = false;

    let parsedCooldown = parseInt(this.cooldownDurationValue, 10);

    if (Number.isNaN(parsedCooldown) || parsedCooldown <= 0) {
      parsedCooldown = 5000;
    }
    this.parsedCooldownDuration = parsedCooldown;

    this.startInitialCooldown();
  }

  processClick(event) {
    if (this.isCoolingDown) {
      event.preventDefault();
      return;
    }
    this.element.textContent = "Sending...";
    this.element.classList.add("opacity-50");
  }

  startInitialCooldown() {
    if (this.isCoolingDown) return;

    this.isCoolingDown = true;
    const waitTextToShow = this.hasWaitTextValue
      ? this.waitTextValue
      : `Wait ${this.parsedCooldownDuration / 1000}s...`;

    this.element.textContent = waitTextToShow;
    this.element.classList.add("opacity-50", "pointer-events-none");

    if (this.cooldownTimeout) {
      clearTimeout(this.cooldownTimeout);
    }

    this.cooldownTimeout = setTimeout(() => {
      this.endCooldown();
    }, this.parsedCooldownDuration);
  }

  endCooldown() {
    this.element.textContent = this.originalText;
    this.element.classList.remove("opacity-50", "pointer-events-none");
    this.isCoolingDown = false;
  }

  disconnect() {
    if (this.cooldownTimeout) {
      clearTimeout(this.cooldownTimeout);
    }
  }
}
